import React, {Component} from 'react';
import {
    Card,
    Tabs,
    Button,
    Input,
    Modal,
    Icon,
    Popover,
    Empty,
    Avatar,
    Dropdown,
    Menu, Table, Pagination, Spin
} from "antd";
import {HEADER_HEIGHT, NAVIGATE_LEVEN2_MARGIN, NAVIGATE_LEVEN2_WIDTH} from "../../../constants";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import "./weiboList.css";
import {
    getWeiboListByType,
    getCounts,
    getUserInfo,
    getGoProveData,
    getIfProveSuccessData,
    getAllEmotionsList,
    getRepostListById,
    getLikeListById,
    getCommentsByWeiboId,
    createComment,
    replyComment,
    delComment, getMediaById, deleteWeibo, getTodoListList, saveStatusName, getRevokeWeibo, updateProcessData
} from "./weiboActions";
import {formatDate, uuid, showCommentEmotions} from "../../../utils";
import EditWeiBo from "./editWeiBo";
import {WeiboPicturesWall} from "./weiboPicturesWall";
import {Scrollbars} from "react-custom-scrollbars";
import * as utils from "../../../utils";
import PrivateLetter from './PrivateLetter';
import Headlines from './Headlines';
import noAuth from './img/noAuth.png';
import $ from "jquery";
import {getColorByState} from "../../components/colorByState/colorByState";

const {TabPane} = Tabs;
const {Search} = Input;
const {Meta} = Card;
const {confirm} = Modal;

class AllWeiboList extends Component {
    queryStr = "";
    weiboOpenId = "";
    default = {
        start: 1,
        size: 10
    };
    domain = "";
    numberOfOAuth = 0;

    constructor(props) {
        super(props);
        this.state = {
            currentMediaId: this.props && this.props.match && this.props.match.params && this.props.match.params.mediaId ? this.props.match.params.mediaId : '',
            allDataSource: [],
            auditDataSource: [],
            releaseDataSource: [],
            abandonDataSource: [],
            timetaskDataSource: [],
            undoDataSource: [],
            visible: false,
            confirmLoading: false,
            modalTitle: "发微博",
            userInfo: {},//当前用户信息
            emotionsDataSource: [],//表情包数据
            emotionsDataMap: {},//表情包数据对应的图片链接
            touTiaoParms: {},
            isMediaVisible: false,
            authVisible: false,
            mediaId: [],
            selectKey: "all",
            dataSource: [],
            total: 0,
            hideOnSinglePage: true,
            isIdentification: true,
            headlinesKey: uuid(),
            isDisabled: false,
            loadTableKey: uuid(),
            mediaLogo: "",
            noInfoCheckRecord: [],// 没有记录的检测操作
            editWeiBoUuid: uuid(), // 编辑微博弹窗的key
        };
    }

    componentDidMount() {
        this.initDataSource(this.state.currentMediaId, this.state.selectKey, this.queryStr, this.default.start, this.default.size);
        this.getMediaInfoById(this.state.currentMediaId);
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;    //防止内存泄露
        };
    }

    getMediaInfoById(mediaId) {
        let params = {
            mediaId,
        }
        if (!mediaId) {
            return
        }
        getMediaById(params, (data) => {
            this.state.mediaName = data?.name;
            if (data && data.authResult) {
                this.state.mediaLogo = data.mediaLogo;
                this.initUserInfo();
                this.initEmotionsDataSource();
            } else {
                this.setState({
                    isMediaVisible: true,
                    userInfo: {},
                    isIdentification: false
                })
            }
            if (data && !data.disable) {
                this.setState({
                    isDisabled: false
                })
            } else {
                this.setState({
                    isDisabled: true
                })
            }
        })
    }

    refresh() {
        this.refreshList();
    }

    initEmotionsDataSource() {
        let params = {
            mediaId: this.state.currentMediaId,
            type: "face"
        }
        getAllEmotionsList(params, (data) => {
            let map = {};
            let emotionsDataSource = [];
            if (data && data.length) {
                data.forEach(item => {
                    map[item.value] = item.icon;
                    if (item.category) {
                        for (var i = 0; i < emotionsDataSource.length; i++) {
                            // 对比相同的字段key，相同放入对应的数组
                            if (emotionsDataSource[i].category === item.category) {
                                emotionsDataSource[i].emotion.push({
                                    ...item
                                });
                                return;
                            }
                        }
                        emotionsDataSource.push({
                            category: item.category,
                            emotion: [{...item}]
                        })
                    }
                });
            }
            this.setState({
                emotionsDataSource,
                emotionsDataMap: map
            });
        });
    }

    initUserInfo() {
        let body = {
            mediaId: this.state.currentMediaId
        }
        getUserInfo(body, (data) => {
            if (data) {
                this.state.isIdentification = true;
                if (data.profile_url && data.profile_url !== "") {
                    this.state.userInfo = data;
                    this.domain = "https://www.weibo.com/" + data.profile_url;
                    this.setState({});
                } else {
                    this.setState({
                        isMediaVisible: false,
                        userInfo: {}
                    });
                }
            }
        });
    }

    authHandleCancel = e => {
        this.setState({
            isMediaVisible: false,
        });
    };
    authCancel = e => {
        this.setState({
            authVisible: false,
        });
    };

    // 去认证
    getGoProveDatas() {
        let params = {
            mediaId: this.state.currentMediaId
        }
        getGoProveData(params, (res) => {
            if (res) {
                let keyCode = res.keycode;
                let openUrl = res.openurl;
                window.open(openUrl);
                this.getIfProveSuccessDatas(this.state.currentMediaId, keyCode)
            } else {
                message.error('认证失败，请检查媒体信息！');
            }
        });
    }

    // 检查是否认证成功
    getIfProveSuccessDatas(mediaId, keyCode) {
        let that = this;
        let params = {
            mediaId: mediaId,
            keyCode: keyCode
        }
        getIfProveSuccessData(params, (data) => {
            if (data) {
                this.setState({
                    authVisible: true,
                    isMediaVisible: false
                })
                this.initUserInfo()
            } else {
                this.setState({
                    isIdentification: false
                })
                if (that.numberOfOAuth < 20) {
                    /**反复验证*/
                    setTimeout(function () {
                        that.numberOfOAuth = that.numberOfOAuth + 1;
                        that.getIfProveSuccessDatas(mediaId, keyCode)
                    }, 3000);
                }
            }
        })
    }

    initDataSource(currentMediaId, type, queryStr, start, size) {
        if (type === "undo") {
            let params = {
                operatorUser: window.top.currentUser.id,
                fieldQuery: {
                    queryRelationTypeEnum:"AND",
                    queryList: [
                        {
                            fieldName: "processData.data.mediaId",
                            queryTypeEnum: "IS",
                            valueTypeEnum: "STRING",
                            value: this.state.currentMediaId,
                            queryRelationTypeEnum: "AND",
                            queryList: null
                        },
                    ]
                },
                activitiCategoryKeys: ["weibo"],
                page: {
                    size: size,
                    start: start
                },
                showData: true,
                title: queryStr,
            };
            getTodoListList(params, (data) => {
                let dataSource = [];
                let total = 0;
                if (data && data.data && data.data.length && this.state.isIdentification) {
                    data.data.forEach(item => {
                        dataSource.push(item.data);
                    })
                    total = data.count;
                }
                this.state.hideOnSinglePage = total <= 10;
                this.setState({
                    dataSource,
                    total
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                });
            });
        } else {
            let params = {
                page: start,
                size: size,
                keywords: queryStr,
                mediaId: currentMediaId
            }
            getWeiboListByType(params, (data) => {
                let dataSource = [];
                let total = 0;
                if (data && data.data.length) {
                    dataSource = data.data;
                    total = data.count;
                }
                this.state.hideOnSinglePage = total <= 10;
                this.setState({
                    dataSource,
                    total
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                });
            }, type);
        }
    }

    loadCountData(data) {
        let weiboIds = "";
        for (let i = 0; data && i < data.length; i++) {
            let wbid = data[i].weibo_id;
            if (wbid && wbid > 0) {
                if (i == 0) {
                    weiboIds += (wbid + "");
                } else {
                    weiboIds += ("," + wbid);
                }
            }
        }
        //查询已发布微博的点赞数等信息
        if (weiboIds !== "") {
            getCounts(this.state.mediaCode, weiboIds, (data) => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let weibo_mid = data[i].id;
                        let returnObj = {};
                        returnObj.attitudes = data[i].attitudes;
                        returnObj.comments = data[i].comments;
                        returnObj.reposts = data[i].reposts;
                        this.setWeiboCounts(weibo_mid, returnObj)
                    }
                }
            });
        }
    }

    openWeiboInfo() {
        if (this.domain !== "") {
            window.open(this.domain);
        }
    }

    handleOk = () => {
        if (this.callback) {
            this.callback()
        }
        this.setState({
            confirmLoading: true,
        });
        setTimeout(() => {
            this.setState({
                visible: false,
                confirmLoading: false,
            });
        }, 2000);
    };

    // 微博编辑页面是否正在loading
    childLoading = false;

    handleCancel = () => {
        if (this.callback) {
            this.callback()
        }
        console.log(this.editWeibo)
        if(this.editWeibo?.needRefreshList) {
            this.refreshList();
        }
        if (!this.childLoading) {
            this.setState({
                visible: false,
            });
        }
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    setWeiboCounts(mid, countObj) {
        let dataType = this.type;
        if (dataType === "all") {
            this.setState(prevState => {
                let allDataSource = prevState.allDataSource;
                for (let i = 0; i < allDataSource.length; i++) {
                    let weibo = allDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {allDataSource}
            });
        } else if (dataType === "audit") {
            this.setState(prevState => {
                let auditDataSource = prevState.auditDataSource;
                for (let i = 0; i < auditDataSource.length; i++) {
                    let weibo = auditDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {auditDataSource}
            });
        } else if (dataType === "release") {
            this.setState(prevState => {
                let releaseDataSource = prevState.releaseDataSource;
                for (let i = 0; i < releaseDataSource.length; i++) {
                    let weibo = releaseDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {releaseDataSource}
            });
        } else if (dataType === "abandon") {
            this.setState(prevState => {
                let abandonDataSource = prevState.abandonDataSource;
                for (let i = 0; i < abandonDataSource.length; i++) {
                    let weibo = abandonDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {abandonDataSource}
            });
        } else if (dataType === "timetask") {
            this.setState(prevState => {
                let timetaskDataSource = prevState.timetaskDataSource;
                for (let i = 0; i < timetaskDataSource.length; i++) {
                    let weibo = timetaskDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {timetaskDataSource}
            });
        } else if (dataType === "undo") {
            this.setState(prevState => {
                let undoDataSource = prevState.undoDataSource;
                for (let i = 0; i < undoDataSource.length; i++) {
                    let weibo = undoDataSource[i]
                    if (weibo.mid === mid) {
                        if (countObj) {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {undoDataSource}
            });
        }
    }

    removeWeibo = (id) => {
        //仅删除微博列表中的那条数据，删除API在弹窗中调用
        let dataType = this.state.selectKey;
        if (dataType === "all") {
            this.setState(prevState => {
                let allDataSource = prevState.allDataSource;
                allDataSource = allDataSource.filter(weibo => weibo.id !== id);
                return {allDataSource}
            });
        } else if (dataType === "audit") {
            this.setState(prevState => {
                let auditDataSource = prevState.auditDataSource;
                auditDataSource = auditDataSource.filter(weibo => weibo.id !== id);
                return {auditDataSource}
            });
        } else if (dataType === "release") {
            this.setState(prevState => {
                let releaseDataSource = prevState.releaseDataSource;
                releaseDataSource = releaseDataSource.filter(weibo => weibo.id !== id);
                return {releaseDataSource}
            });
        } else if (dataType === "abandon") {
            this.setState(prevState => {
                let abandonDataSource = prevState.abandonDataSource;
                abandonDataSource = abandonDataSource.filter(weibo => weibo.id !== id);
                return {abandonDataSource}
            });
        } else if (dataType === "timetask") {
            this.setState(prevState => {
                let timetaskDataSource = prevState.timetaskDataSource;
                timetaskDataSource = timetaskDataSource.filter(weibo => weibo.id !== id);
                return {timetaskDataSource}
            });
        } else if (dataType === "undo") {
            this.setState(prevState => {
                let undoDataSource = prevState.undoDataSource;
                undoDataSource = undoDataSource.filter(weibo => weibo.id !== id);
                return {undoDataSource}
            });
        }
    };

    refreshList = () => {
        this.state.visible = false;
        if (this.callback) {
            this.callback()
        }
        this.initDataSource(this.state.currentMediaId, this.state.selectKey, this.queryStr, this.default.start, this.default.size);
    };

    showWeibo = (id, mediaId, callback) => {
        this.callback = callback;
        this.weiboOpenId = id;
        if (mediaId) {
            this.state.currentMediaId = mediaId;
        }
        this.setState({
            visible: true,
        })
    }

    renderTitle(record) {
        let fileList = [];
        record.picUrls.map((item, i) => {
            let file = {};
            file.name = "";
            file.status = "done";
            file.uid = i;
            file.url = item;
            fileList.push(file);
        })
        return (
            <div>
                <div style={{display: "flex", alignItems: "center"}}>
                    <div title={record.submitterName} style={{
                        fontSize: "16px",
                        color: window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',
                        fontWeight: 400,
                        marginRight: 10,
                        maxWidth: "730px",
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>{record.submitterName}</div>
                    {record.createTime ?
                        <div style={{
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "rgba(0, 0, 0, 0.45)"
                        }}>创作于 {formatDate(record.createTime)}</div> : ""}
                </div>
                <div style={{marginTop: "10px"}}>
                    <span title={record.title} style={{
                        cursor: "pointer",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        wordBreak: "break-all",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}>{showCommentEmotions(record.title, this.state.emotionsDataMap)}</span>
                </div>
                {record.cover ?
                    <div style={{position: 'relative', marginTop: record.cover ? "10px" : ""}}>
                        <img src={record.cover}
                             style={{width: 600, height: 257, objectFit: 'cover', cursor: 'pointer'}} alt=""
                        />
                        <div style={{
                            width: 600,
                            background: 'rgba(0, 0, 0, 0.45)',
                            position: "absolute",
                            bottom: 0,
                            color: "rgba(255, 255, 255, 0.85)",
                            fontSize: 14,
                            padding: 10
                        }}>
                            <div title={record.title} style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                wordWrap: 'break-word',
                                overflow: 'hidden'
                            }}>{record.title}</div>
                            <div title={record.summary} style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                wordWrap: 'break-word',
                                overflow: 'hidden'
                            }}>{record.summary}</div>
                        </div>
                        <div>
                        </div>
                    </div>
                    :
                    <div style={{marginTop: fileList.length ? "10px" : ""}} onClick={(e) => {e.stopPropagation()}}>
                        <WeiboPicturesWall fileList={fileList} isShowRemoveBtn={false} listShow={true}/>
                    </div>
                }
                {/*分享、点赞、评论*/}
                <WeiboActive key={"weibo" + record.id}
                             {...record}
                             refresh={() => {
                                 this.refreshList()
                             }}
                             mediaLogo={this.state.mediaLogo}
                             emotionsDataSource={this.state.emotionsDataSource}
                             emotionsDataMap={this.state.emotionsDataMap}
                             userInfo={this.state.userInfo}
                />
            </div>
        )
    }

    deleteWeibo(record) {
        confirm({
            title: '是否要删除本条微博 ？',
            onOk: () => {
                deleteWeibo({id: record.id}, (data) => {
                    if (data) {
                        message.success("删除成功");
                        if (this.state.dataSource.length === 1 && this.default.start > 1) {
                            this.paginationOnChange(this.default.start - 1, this.default.size)
                        } else {
                            this.paginationOnChange(this.default.start, this.default.size)
                        }
                    } else {
                        message.error("删除失败");
                    }
                })
            },
            onCancel() {
            },
        });
    }

    render() {
        let width = window.document.body.clientWidth - NAVIGATE_LEVEN2_WIDTH - NAVIGATE_LEVEN2_MARGIN - 359;
        let bHeight = window.innerHeight - parseInt(HEADER_HEIGHT) - 15;
        const menu = (
            <Menu>
                <Menu.Item disabled={this.state.isIdentification ? null : "disabled"} key="1" onClick={() => {
                    this.state.touTiaoParms = {};//清空参数
                    this.state.noInfoCheckRecord = [];//清空参数
                    this.weiboOpenId = "";
                    this.setState({});
                    this.showWeibo("")
                }}
                >发微博</Menu.Item>
                <Menu.Item disabled={this.state.isIdentification ? null : "disabled"} key="2" onClick={() => {
                    this.weiboOpenId = "";
                    this.state.touTiaoParms = {};//清空参数
                    this.state.noInfoCheckRecord = [];//清空参数
                    this.weiboOpenId = "";
                    this.setState({});
                    this.Headlines.showModal({isAdd: true})
                }}
                >头条文章</Menu.Item>
            </Menu>
        );
        const weiboListColumns = [
            {
                title: '标题',
                key: 'name',
                width: "60%",
                render: (record) => {
                    return (
                        <div>
                            {this.renderTitle(record)}
                        </div>
                    )
                }
            },
            {
                title: '修改时间',
                key: 'newMediaTypeName',
                ellipsis: true,
                width: "15%",
                render: (record) => {
                    return (
                        <div title={record.updateTime ? formatDate(record.updateTime) : ""} style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            <span style={{
                                fontSize: "14px",
                                color: "#999999",
                            }}>{record.updateTime ? formatDate(record.updateTime) : ""}</span>
                        </div>
                    )
                }
            },
            {
                title: '状态',
                key: 'statusName',
                dataIndex: 'statusName',
                ellipsis: true,
                width: "15%",
                render: (text) => {
                    let color = getColorByState(text);
                    return (
                        <div className={'dotState'}>
                            <div style={{background: color}}></div>
                            {text}
                        </div>
                    )
                }
            },
            {
                title: '操作',
                key: 'operate',
                ellipsis: true,
                width: "10%",
                render: (record) => {
                    return (
                        <div onClick={(e) => {
                            e.stopPropagation();
                        }}>
                            {((record.statusName === "草稿" || record.statusName.indexOf("撤稿") > -1 || record.statusName.indexOf("弃用") > -1 || record.statusName.indexOf("失败") > -1) && window.top.currentUser.id === record.submitter) ?
                                <span style={{cursor: "pointer", color: "red"}}
                                      onClick={() => this.deleteWeibo(record)}>删除</span> :
                                (record.statusName === "已发布") ? <div style={{display: 'flex', justifyContent: 'left'}}>
                                    <span style={{cursor: "pointer", color:  window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',}}
                                          onClick={() => {
                                              window.open(record.publishUrl);
                                          }}
                                    >访问</span>
                                    <span style={{marginLeft: 20, cursor: "pointer", color:  window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',}}
                                          onClick={(id) => this.getRevokeWeibo(record)}
                                    >撤稿</span>
                                </div> : <span>-</span>
                            }
                        </div>
                    )
                }
            }
        ];
        return (
            <div style={{padding: "15px", height: bHeight, overFlow: 'hidden'}} id={"weiboCard"}>
                <style>{`#weiboCard .ant-card-meta-detail{overflow: initial;}
                .weiboModal,.weiboEditModal .ant-modal-header .ant-modal-title{font-family: "Microsoft YaHei";font-weight: bold;}
                .weiboModal,.weiboEditModal .ant-modal-close{color: rgba(0, 0, 0, 0.85);}
                .weiboEditModal .ant-modal-body{padding: 0px}
                #weiboCard .ant-card-bordered{border: 0;}
                `}</style>
                <Card
                    title={
                        <div style={{display: 'flex', alignItems: "center", height: 108}}>
                            <Meta
                                avatar={<Avatar style={{width: 88, height: 88}}
                                                src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}/>}
                                description={
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                        <div style={{margin: "12px 0px", display: "flex", alignItems: "center"}}>
                                            <div className={"weiboTitle"} title={this.state.userInfo.screen_name}>
                                                {this.state.isIdentification ? this.state.userInfo.screen_name : "未认证"}
                                            </div>
                                            <div className={"weiboAuth"} style={{marginLeft: 15}}>
                                                {this.state.isIdentification ?
                                                    <span onClick={() => {
                                                        this.openWeiboInfo()
                                                    }}>查看微博<span style={{marginLeft: "5px"}}><Icon type="double-right"/></span></span> :
                                                    <span onClick={() => this.getGoProveDatas()}>去认证<span
                                                        style={{marginLeft: "5px"}}><Icon
                                                        type="double-right"/></span></span>}
                                            </div>
                                        </div>
                                        <div>
                                            <span className={"weiboShow"}>关注：</span><span
                                            className={"weiboCount"}>{this.state.userInfo.friends_count ? this.state.userInfo.friends_count : 0}</span>
                                            <span className={"weiboShow"} style={{marginLeft: 24}}>粉丝：</span><span
                                            className={"weiboCount"}>{this.state.userInfo.followers_count ? this.state.userInfo.followers_count : 0}</span>
                                            <span className={"weiboShow"} style={{marginLeft: 24}}>微博：</span><span
                                            className={"weiboCount"}>{this.state.userInfo.statuses_count ? this.state.userInfo.statuses_count : 0}</span>
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    }
                    extra={
                        <div id={"dropdownBtn"} style={{display: this.state.isDisabled ? "none" : "block"}}>
                            {this.state.isIdentification ? null :
                                <Button onClick={() => this.getGoProveDatas()}>去认证</Button>}
                            <Dropdown.Button onClick={(e) => {
                                e.preventDefault();
                                this.state.touTiaoParms = {};//清空参数
                                this.state.noInfoCheckRecord = [];//清空参数
                                this.weiboOpenId = "";
                                this.setState({});
                                this.showWeibo("")
                            }}
                                             disabled={this.state.isIdentification ? null : "disabled"}
                                             style={{margin: "0px 8px 0px 16px"}}
                                             overlay={menu}
                                             placement="bottomRight"
                                             type={"primary"}>创建</Dropdown.Button>
                            <style>{`#dropdownBtn .ant-btn{padding: 0px 7px;}
                            #dropdownBtn .ant-btn-group .ant-btn + .ant-btn{margin-left: 1px;}`}</style>
                        </div>
                    }
                    style={{width: "100%", borderRadius: "2px"}} bodyStyle={{padding: "0px"}}
                    headStyle={{border: "0px"}}/>
                <div style={{
                    backgroundColor: "#fff",
                    marginTop: 14,
                    borderRadius: "2px",
                    height: window.innerHeight - parseInt(HEADER_HEIGHT) - 184
                }}>
                    <div style={{padding: "24px 0px 0px 32px"}}>
                        <Search placeholder="请输入关键字" style={{width: "15%"}} allowClear
                                onSearch={value => this.searchWeiBo(value)}/>
                    </div>
                    <div style={{marginTop: 10}} className={"tabsTitle"}>
                        <Tabs activeKey={this.state.selectKey} onChange={(key) => {
                            this.default = {
                                start: 1,
                                size: 10
                            }
                            this.state.loadTableKey = uuid();
                            this.setState({
                                selectKey: key
                            }, () => {
                                this.initDataSource(this.state.currentMediaId, key, this.queryStr, this.default.start, this.default.size);
                            })
                        }}>
                            <TabPane key={"all"} tab={"全部微博"}/>
                            <TabPane key={"drafts"} tab={"草稿箱"}/>
                            <TabPane key={"auditing"} tab={"审核中"}/>
                            <TabPane key={"undo"} tab={"待我处理"}/>
                            <TabPane key={"release"} tab={"已发布"}/>
                            <TabPane key={"abandon"} tab={"已撤稿"}/>
                        </Tabs>
                    </div>
                    <div style={{
                        padding: "0px 32px",
                        marginTop: 18,
                        height: !this.state.hideOnSinglePage ? document.body.clientHeight - HEADER_HEIGHT - 364 : document.body.clientHeight - HEADER_HEIGHT - 326,
                        backgroundColor: "#fff"
                    }} id={"weiboTable"}>
                        <Scrollbars key={this.state.loadTableKey} autoHeight
                                    autoHeightMax={!this.state.hideOnSinglePage ? document.body.clientHeight - HEADER_HEIGHT - 374 : document.body.clientHeight - HEADER_HEIGHT - 336}>
                            {this.state.dataSource.length ?
                                <Table
                                    style={{padding: "0px 10px"}}
                                    onRow={record => {
                                        return {
                                            onClick: event => {
                                                this.state.touTiaoParms = {};
                                                this.state.noInfoCheckRecord = [];//清空参数
                                                this.weiboOpenId = "";
                                                this.showWeibo(record.id);
                                            }, // 点击行
                                        };
                                    }}
                                    columns={weiboListColumns} dataSource={this.state.dataSource} pagination={false}
                                    locale={{emptyText: '暂无数据'}} rowClassName={"tableRow"}
                                /> : <Empty style={{marginTop: 160}}/>}
                            <style>{`
                            #weiboTable .ant-table-bordered .ant-table-thead > tr > th, .ant-table-bordered .ant-table-tbody > tr > td{border-right: 0;}
                            #weiboTable .tableRow{border-bottom: 1px solid rgba(0, 0, 0, 0.15);cursor: pointer;}
                            #weiboTable .ant-table table{border-collapse: collapse;}
                            `}</style>
                        </Scrollbars>
                    </div>
                    <div style={{padding: "0px 20px 10px 10px", display: "flex", justifyContent: "flex-end"}}>
                        <Pagination
                            onChange={(page, pageSize) => {
                                this.paginationOnChange(page, pageSize)
                            }}//页码改变回调
                            onShowSizeChange={(page, pageSize) => {
                                this.state.hideOnSinglePage = false;
                                page = 1;
                                this.paginationOnChange(page, pageSize)
                            }}//每页条数改变回调
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={this.state.total}
                            showTotal={total => `共${total}条`}
                            current={this.default.start}
                            pageSize={this.default.size}
                            showSizeChanger
                            showQuickJumper
                            hideOnSinglePage={this.state.hideOnSinglePage}
                        />
                    </div>
                </div>
                {this.renderEditorModal()}
                {/*<Modal title="提示" width={400} className="weiboModal" visible={this.state.isMediaVisible} centered*/}
                {/*       footer={*/}
                {/*           <div style={{display: "flex", justifyContent: "center",}}>*/}
                {/*               <div onClick={this.authHandleCancel}>*/}
                {/*                   <Button>取消</Button>*/}
                {/*               </div>*/}
                {/*               <div style={{marginLeft: "24px"}}>*/}
                {/*                   <Button type="primary"*/}
                {/*                           onClick={() => this.getGoProveDatas()}>认证</Button>*/}
                {/*               </div>*/}
                {/*           </div>*/}
                {/*       } onCancel={this.authHandleCancel}>*/}
                {/*    <div className={"authOutOfDate"}>*/}
                {/*        此账号授权已过期，认证后方可正常使用！*/}
                {/*    </div>*/}
                {/*</Modal>*/}
                <Modal
                    centered
                    title="提示"
                    width={400}
                    visible={this.state.isMediaVisible}
                    okText="认证"
                    onOk={() => {
                        this.getGoProveDatas()
                    }}
                    onCancel={() => {
                        this.authHandleCancel()
                    }}>
                    <p>此账号授权已过期，认证后方可正常使用！</p>
                </Modal>


                <Modal title="提示" visible={this.state.authVisible} centered footer={null}
                       onCancel={this.authCancel}>
                    <div>
                        认证成功！
                    </div>
                </Modal>
                <PrivateLetter mediaCode={this.state.mediaCode} ref={(PrivateLetter) => {
                    this.PrivateLetter = PrivateLetter
                }}/>
                <Headlines
                    ref={(Headlines) => {
                        this.Headlines = Headlines
                    }}
                    noInfoCheckRecord={this.state.noInfoCheckRecord}
                    callback={(data,noInfoCheckRecord) => {
                        this.weiboOpenId = data?.initWeiBoId || "";
                        this.setState({
                            visible: true,
                            touTiaoParms: data,
                            noInfoCheckRecord
                        })
                    }}
                    key={this.state.headlinesKey}
                    handleCancelCall={() => {
                        this.setState({
                            headlinesKey: uuid()
                        })
                    }}
                />
            </div>
        );
    }

    renderEditorModal = () => {
        return (
            <Modal
                className="weiboEditModal"
                title={this.state.modalTitle}
                visible={this.state.visible}
                onCancel={()=>{this.handleCancel()}}
                onOk={this.handleOk}
                centered={true}
                footer={null}
                width={"auto"}
                maskClosable={false}
                destroyOnClose={true}
            >
                <div>
                    <EditWeiBo
                        key={this.state.editWeiBoUuid}
                        touTiaoParms={this.state.touTiaoParms}
                        noInfoCheckRecord={this.state.noInfoCheckRecord}
                        weiboId={this.weiboOpenId}
                        onSaveCall={(weiboOpenId)=>{
                            // 点击暂存的回调
                            this.state.touTiaoParms = {};
                            this.state.noInfoCheckRecord = [];//清空参数
                            this.weiboOpenId = weiboOpenId;
                            // this.initDataSource(this.state.currentMediaId, this.state.selectKey, this.queryStr, this.default.start, this.default.size);
                            this.setState({})
                        }}
                        onCheckNoInfoCall={(key)=>{
                            if(key) {
                                this.state.noInfoCheckRecord = this.state.noInfoCheckRecord.filter(item=>item.key!==key)
                            }
                        }}
                        ref={(c) => {
                            this.editWeibo = c
                        }}
                        touTiaoParmsCallback={(data,noInfoCheckRecord) => {
                            //回调传入微博头条编辑器
                            let parms = {
                                ...data,
                            };
                            this.state.visible = false;
                            this.setState({noInfoCheckRecord:[]});
                            this.Headlines.showModal(parms,noInfoCheckRecord)
                        }} currentMedia={this.state.currentMediaId}
                        userInfo={this.state.userInfo}
                        emotionsDataSource={this.state.emotionsDataSource}
                        removeWeibo={this.removeWeibo.bind(this)}
                        refreshList={this.refreshList.bind(this)}
                        fatherObj={this}
                        mediaName={this.state.mediaName}
                        isDisabled={this.state.isDisabled}
                        changeLoading={(status) => {
                            this.childLoading = status
                        }}
                    />
                </div>
            </Modal>
        )
    };

    getRevokeWeibo(record) {
        let that = this;
        confirm({
            title: '是否要撤稿本条微博 ？',
            onOk: () => {
                getRevokeWeibo({id: record.id}, (data) => {
                    if (data) {
                        let params = {
                            id: record.id,
                            statusName: "已撤稿"
                        };
                        saveStatusName(params, (data) => {
                            message.success("撤稿成功");
                            that.refreshList();
                            that.updateProcessStatusData(record)
                        });
                    } else {
                        message.error("撤稿失败");
                    }
                });
            },
            onCancel() {
            },
        });
    }

    updateProcessStatusData(record) {
        let params = {
            bizKey: record.id,
            operatorUser: window.top.currentUser.id,
            taskName: "已撤稿",
            data: record
        }
        updateProcessData(params, (data) => {
        });
    }

    searchWeiBo = (value) => {
        this.queryStr = value;
        this.default.start = 1;
        this.state.loadTableKey = uuid();
        this.initDataSource(this.state.currentMediaId, this.state.selectKey, value, this.default.start, this.default.size);
    };

    paginationOnChange(page, pageSize) {
        this.default.start = page;
        this.default.size = pageSize;
        this.state.loadTableKey = uuid();
        this.initDataSource(this.state.currentMediaId, this.state.selectKey, this.queryStr, this.default.start, this.default.size);
    }
}

export default AllWeiboList;

class WeiboActive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            sharedVisible: false,
            likedVisible: false,
            markedVisible: false,
            emotionsDataSource: this.props.emotionsDataSource,
            emotionsDataMap: this.props.emotionsDataMap,
            type: "face",
            myInput: '',
            pageNo: 1,//评论
            pageSize: 10,//评论
            markList: [],//评论列表
            markIsLast: false,
            pageNoLiked: 1,//点赞
            pageSizeLiked: 10,//点赞
            likedList: [],//点赞列表
            likedIsLast: false,
            pageNoShare: 1,//分享
            pageSizeShare: 10,//分享
            shareList: [],//分享列表
            shareIsLast: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    componentDidMount() {

    }

    render() {
        return (
            <div style={{width: "100%"}} onClick={(e) => {e.stopPropagation();}}>
                {this.props.statusName === '已发布' ?
                    <div style={{paddingTop: this.props.cover ? "20px" : ""}}>
                    <span style={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.65)",
                        fontWeight: 500,
                        cursor: 'pointer',
                        marginRight: "10px"
                    }}
                          onClick={() => {
                              this.state.pageNoShare = 1;
                              this.getShare()
                          }}
                    >
                        分享：<span
                        style={{fontWeight: 700}}>{this.props.statistics.reposts ? this.props.statistics.reposts : "0"}</span>
                    </span>
                        <span onClick={() => {
                            this.state.pageNoLiked = 1;
                            this.getLiked()
                        }} style={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.65)",
                            fontWeight: 500,
                            cursor: 'pointer',
                            marginRight: "10px"
                        }}>
                        点赞：<span
                            style={{fontWeight: 700}}>{this.props.statistics.attitudes ? this.props.statistics.attitudes : "0"}</span>
                    </span>
                        <span onClick={() => {
                            this.state.pageNo = 1;
                            this.getMarked();
                        }} style={{fontSize: "14px", color: "rgba(0, 0, 0, 0.65)", fontWeight: 500, cursor: 'pointer'}}>
                                评论：<span
                            style={{fontWeight: 700}}>{this.props.statistics.comments ? this.props.statistics.comments : "0"}</span>
                    </span>
                    </div> : null}
                {this.renderShared()}
                {this.renderLiked()}
                {this.renderMarked()}
            </div>
        );
    }

    //获取分享
    getShare() {
        let body = {
            id: this.props.id,
            pageNo: this.state.pageNoShare,
            pageSize: this.state.pageSizeShare
        };
        if (this.state.pageNoShare === 1) {
            this.state.shareList = [];
        }
        getRepostListById(body, (data) => {
            if (data && data.reposts) {
                if (data.reposts && data.reposts.length < this.state.pageSizeShare && data.reposts.length === 0) {
                    this.state.shareIsLast = true;
                } else {
                    this.state.shareIsLast = false
                }
                if (this.state.pageNoShare === 1) {
                    this.setState({
                        shareList: data.reposts,
                        sharedVisible: true
                    });
                } else {
                    this.setState({
                        shareList: this.state.shareList.concat(data.reposts),
                        sharedVisible: true
                    });
                }
            } else {
                this.state.shareIsLast = true;
                this.setState({
                    shareList: [],
                    sharedVisible: true
                });
            }
        })
    }

    //获取点赞
    getLiked() {
        let body = {
            id: this.props.id,
            pageNo: this.state.pageNoLiked,
            pageSize: this.state.pageSizeLiked
        };
        if (this.state.pageNoLiked === 1) {
            this.state.likedList = [];
        }
        getLikeListById(body, (data) => {
            if (data && data.attitudes) {
                if (data.attitudes && data.attitudes.length < this.state.pageSizeLiked) {
                    this.state.likedIsLast = true
                } else {
                    this.state.likedIsLast = false
                }
                if (this.state.pageNoLiked === 1) {
                    this.setState({
                        likedList: data.attitudes,
                        likedVisible: true
                    });
                } else {
                    this.setState({
                        likedList: this.state.likedList.concat(data.attitudes),
                        likedVisible: true
                    });
                }
            } else {
                this.state.likedIsLast = true
                this.setState({
                    likedList: [],
                    likedVisible: true
                });
            }

        })
    }

    //获取评论数据
    getMarked() {
        let body = {
            id: this.props.id,
            pageNo: this.state.pageNo,
            pageSize: this.state.pageSize
        };
        getCommentsByWeiboId(body, (data) => {
            let comments = [];
            if (this.state.pageNo === 1) {
                if (data && data.comments) {
                    comments = data.comments;
                    if (data.comments.length < this.state.pageSize) {
                        this.state.markIsLast = true;
                    }
                } else {
                    this.state.markIsLast = true;
                }
                this.setState({markedVisible: true})
            } else {
                if (data && data.comments) {
                    if (data.comments.length > 0) {
                        comments = this.state.markList.concat(data.comments);
                        if (data.comments.length < this.state.pageSize) {
                            this.state.markIsLast = true;
                        }
                    } else {
                        this.state.markIsLast = true;
                    }

                } else {
                    this.state.markIsLast = true;
                }
                this.setState({})
            }

            // this.state.markList
            // this.state.markList.forEach((item,i)=>{
            //     item.markStatus=false;
            //     item.mark='';
            // });
            let _comments = {}; // 所有的评论
            let _reply = {};    // 所有的回复
            comments.map((item, i) => {
                item.markStatus = false;
                item.mark = '';
                // 评论
                if (item.id === item.rootid) {
                    _comments[item.id] = item;
                } else {
                    // 回复
                    if (!_reply[item.rootid]) {
                        _reply[item.rootid] = [];
                    }
                    _reply[item.rootid].push(item);
                }
            });

            for (var key in _reply) {
                if (_comments[key]) {
                    _comments[key].child = _reply[key];
                }
            }

            let comments_reply_list = Object.values(_comments);
            this.setState({
                markList: comments_reply_list
            })
        });

    }

    renderShared() {
        return (
            <Modal title="分享"
                   visible={this.state.sharedVisible}
                   onOk={() => {
                   }}
                   maskClosable={false}
                   onCancel={() => {
                       this.setState({sharedVisible: false})
                   }}
                   footer={null}
                   width={400}
            >
                <div style={{height: '60vh'}}>
                    <Scrollbars>
                        {this.state.shareList.length ? this.state.shareList.map((item, i) => {
                            let user = item.user;
                            return (
                                <div key={i}>
                                    <div style={{display: 'flex', paddingBottom: 20, paddingTop: 20}}>
                                        <div onClick={() => {
                                            this.openBlankWeiBo(user.idstr)
                                        }}><img style={{width: 35, height: 35, objectFit: 'cover', cursor: 'pointer'}}
                                                src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}
                                                alt=""/></div>
                                        <div style={{
                                            marginLeft: 20
                                        }}>
                                            <div style={{color: '#FF6600', cursor: 'pointer'}} onClick={() => {
                                                this.openBlankWeiBo(user.idstr)
                                            }}>{user.screen_name}</div>
                                            <div>{item.created_at ? utils.timeago(item.created_at) : null}</div>
                                            <div title={item.text} style={{
                                                width: 285,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>{showCommentEmotions(item.text, this.state.emotionsDataMap)}</div>
                                        </div>
                                    </div>
                                    <div style={{height: 1, background: '#f2f2f2'}}></div>
                                </div>
                            )
                        }) : <Empty/>}
                        {
                            this.state.shareList.length ? (
                                    this.state.shareIsLast ? <div style={{
                                        background: '#fff2e6',
                                        fontSize: 12,
                                        color: '#808080',
                                        padding: 5,
                                        textAlign: 'center',
                                    }}>
                                        由于部分用户进行定向转发，你无法查看剩余转发内容。
                                    </div> : null)
                                : null
                        }

                        {
                            this.state.shareIsLast ? null : <div onClick={() => this.shareMore()} style={{
                                height: 30,
                                lineHeight: '30px',
                                textAlign: "center",
                                cursor: 'pointer'
                            }}>加载更多<Icon
                                type="down"/></div>
                        }
                    </Scrollbars>
                </div>
            </Modal>
        )
    }

    renderLiked() {

        return (
            <Modal title="点赞"
                   visible={this.state.likedVisible}
                   onOk={() => {
                   }}
                   maskClosable={false}
                   onCancel={() => {
                       this.setState({likedVisible: false})
                   }}
                   footer={null}
                   width={400}
            >
                <div style={{height: '60vh'}}>
                    <Scrollbars>
                        {this.state.likedList.length ? this.state.likedList.map((item, i) => {
                            let user = item.user;
                            return (
                                <div key={i}>
                                    <div style={{display: 'flex', paddingBottom: 20, paddingTop: 20}}>
                                        <div onClick={() => {
                                            this.openBlankWeiBo(user.idstr)
                                        }}><img style={{width: 35, height: 35, objectFit: 'cover', cursor: 'pointer'}}
                                                src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}
                                                alt=""/></div>
                                        <div style={{
                                            height: 32,
                                            lineHeight: '35px',
                                            marginLeft: 20,
                                            color: '#FF6600', cursor: 'pointer'
                                        }} onClick={() => {
                                            this.openBlankWeiBo(user.idstr)
                                        }}>{user.screen_name}</div>
                                    </div>
                                    <div style={{height: 1, background: '#f2f2f2'}}></div>
                                </div>
                            )
                        }) : <Empty/>}
                        {this.state.likedIsLast ? null :
                            <div style={{height: 30, lineHeight: '30px', textAlign: "center", cursor: 'pointer'}}
                                 onClick={() => {
                                     this.likedMore()
                                 }}
                            >加载更多<Icon
                                type="down"/></div>}

                    </Scrollbars>
                </div>

            </Modal>
        )
    }

    renderMarked() {
        let height = "calc(60vh - " + "100px)";
        return (
            <Modal title="评论"
                   visible={this.state.markedVisible}
                   footer={null}
                   onOk={() => {
                   }}
                   maskClosable={false}
                   onCancel={() => {
                       this.setState({markedVisible: false})
                   }}>
                <div style={{height: '60vh'}}>
                    <div style={{paddingRight: 10}}>
                        <div style={{display: 'flex', paddingBottom: 20}}>
                            <div style={{cursor: 'pointer'}} onClick={() => {
                                this.openBlankWeiBo(this.props.userInfo.idstr)
                            }}><img style={{width: 35, height: 35, objectFit: 'cover'}}
                                    src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}
                                    alt=""/></div>
                            <div style={{width: '88%', marginLeft: 20,}}><Input placeholder="请输入评论内容"
                                                                                maxLength={140}
                                                                                value={this.state.myInput}
                                                                                onChange={(e) => {
                                                                                    this.setState({
                                                                                        myInput: e.target.value
                                                                                    })
                                                                                }}/>
                                <div style={{lineHeight: '32px', paddingTop: 10}}>
                                    <Popover placement="bottomLeft" content={this.renderEmotionsDataSource({})}
                                             trigger="click" style={{width: "20px;"}} arrowPointAtCenter>
                                        <img style={{cursor: "pointer", paddingRight: "10px"}}
                                             src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                    </Popover>
                                    <Button type="primary" style={{float: "right"}} onClick={() => {
                                        this.createWeiboComment()
                                    }}>评论</Button>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div style={{height: height}}>
                        <Scrollbars>
                            <div style={{paddingRight: 10}}>
                                {
                                    this.state.markList.length ? this.state.markList.map((item, i) => {
                                            let user = item.user;
                                            return (
                                                <div style={{display: 'flex', paddingBottom: 20}}>
                                                    <div onClick={() => {
                                                        this.openBlankWeiBo(user.idstr)
                                                    }}><img style={{
                                                        width: 35,
                                                        height: 35,
                                                        objectFit: 'cover',
                                                        cursor: 'pointer'
                                                    }}
                                                            src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}
                                                            alt=""/></div>
                                                    <div style={{width: '88%', marginLeft: 20,}}>
                                                        <div onClick={() => {
                                                            this.openBlankWeiBo(user.idstr)
                                                        }} style={{cursor: 'pointer'}}>
                                                            <span
                                                                style={{color: '#FF6600'}}>{item.user && item.user.screen_name ? item.user.screen_name : null}</span>
                                                            <span
                                                                style={{color: "#000"}}>{item.user && item.user.screen_name ? "：" : null}</span>
                                                            {showCommentEmotions(item.text, this.state.emotionsDataMap)}
                                                        </div>
                                                        <div style={{}}>
                                                            <div style={{
                                                                float: 'left',
                                                                fontSize: 12
                                                            }}>{item.created_at ? utils.timeago(item.created_at) : null}</div>
                                                            <div style={{float: 'right', cursor: 'pointer'}}
                                                                 onClick={() => {
                                                                     item.markStatus = !item.markStatus;
                                                                     this.setState({})
                                                                 }}>回复
                                                            </div>
                                                            {item && item.user && item.user.idstr === this.props.userInfo.idstr ?
                                                                <div
                                                                    style={{
                                                                        float: 'right',
                                                                        marginRight: 20,
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => {
                                                                    this.deleteMark(item)
                                                                }}>删除
                                                                </div> : null}

                                                            <div style={{clear: 'both'}}/>
                                                        </div>

                                                        {item.markStatus ?
                                                            <div style={{width: '100%', marginTop: 20}}><Input
                                                                placeholder="请输入评论内容"
                                                                maxLength={140}
                                                                value={item.mark} onChange={(e) => {
                                                                item.mark = e.target.value;
                                                                this.setState({})
                                                            }}/>
                                                                <div style={{lineHeight: '32px', paddingTop: 10}}>
                                                                    <Popover placement="bottomLeft"
                                                                             content={this.renderEmotionsDataSource(item)}
                                                                             trigger="click" style={{width: "20px;"}}
                                                                             arrowPointAtCenter>
                                                                        <img style={{
                                                                            cursor: "pointer",
                                                                            paddingRight: "10px"
                                                                        }}
                                                                             src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                                                    </Popover>
                                                                    <Button type="primary" style={{float: "right"}}
                                                                            onClick={() => {
                                                                                this.replyComments(item)
                                                                            }}>评论</Button>
                                                                </div>
                                                            </div> : null}

                                                        {/*//评论的子评论*/}
                                                        {
                                                            item.child ? item.child.map((reply, i) => {
                                                                return (
                                                                    <div>
                                                                        <div style={{display: 'flex', paddingBottom: 20}}>
                                                                            <div><img style={{
                                                                                width: 35,
                                                                                height: 35,
                                                                                objectFit: 'cover'
                                                                            }}
                                                                                      src={this.state.mediaLogo ? this.state.mediaLogo : noAuth}
                                                                                      alt=""/></div>
                                                                            <div style={{width: '88%', marginLeft: 20,}}>
                                                                                <div>
                                                                <span
                                                                    style={{color: '#FF6600'}}>{reply.user && reply.user.screen_name ? reply.user.screen_name : null}</span><span
                                                                                    style={{color: "#000"}}>{reply.user && reply.user.screen_name ? "：" : null}</span><span>{showCommentEmotions((reply.reply_comment&&reply.reply_comment.id===reply.reply_comment.rootid) ? reply.reply_original_text : reply.text, this.state.emotionsDataMap)}</span>
                                                                                </div>
                                                                                <div style={{}}>
                                                                                    <div style={{
                                                                                        float: 'left',
                                                                                        fontSize: 12
                                                                                    }}>{reply.created_at ? utils.timeago(reply.created_at) : null}
                                                                                    </div>
                                                                                    <div style={{
                                                                                        float: 'right',
                                                                                        cursor: 'pointer'
                                                                                    }} onClick={() => {
                                                                                        reply.markStatus = !reply.markStatus;
                                                                                        this.setState({})
                                                                                    }}>回复
                                                                                    </div>
                                                                                    {reply && reply.user && reply.user.idstr === this.props.userInfo.idstr ?
                                                                                        <div
                                                                                            style={{
                                                                                                float: 'right',
                                                                                                marginRight: 20,
                                                                                                cursor: 'pointer'
                                                                                            }} onClick={() => {
                                                                                            this.deleteMark(reply)
                                                                                        }}>删除
                                                                                        </div> : null}
                                                                                    <div style={{clear: 'both'}}/>
                                                                                </div>


                                                                            </div>
                                                                        </div>

                                                                        {reply.markStatus ?
                                                                            <div style={{width: '100%', marginTop: 20}}>
                                                                                <Input
                                                                                    placeholder="请输入评论内容"
                                                                                    maxLength={140}
                                                                                    value={reply.mark} onChange={(e) => {
                                                                                    reply.mark = e.target.value;
                                                                                    this.setState({})
                                                                                }}/>
                                                                                <div style={{
                                                                                    lineHeight: '32px',
                                                                                    paddingTop: 10
                                                                                }}>
                                                                                    <Popover placement="bottomLeft"
                                                                                             content={this.renderEmotionsDataSource(reply)}
                                                                                             trigger="click"
                                                                                             style={{width: "20px;"}}
                                                                                             arrowPointAtCenter>
                                                                                        <img style={{
                                                                                            cursor: "pointer",
                                                                                            paddingRight: "10px"
                                                                                        }}
                                                                                             src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                                                                    </Popover>
                                                                                    <Button type="primary"
                                                                                            style={{float: "right"}}
                                                                                            onClick={() => {
                                                                                                this.replyComments(reply)
                                                                                            }}>评论</Button>
                                                                                </div>
                                                                            </div> : null}
                                                                    </div>
                                                                )
                                                            }) : null
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : <Empty/>
                                }
                            </div>
                            {
                                this.state.markIsLast ? null : <div style={{
                                    height: 30,
                                    lineHeight: '30px',
                                    textAlign: "center",
                                    cursor: 'pointer'
                                }} onClick={() => {
                                    this.markMore()
                                }}>加载更多<Icon
                                    type="down"/>
                                </div>
                            }

                        </Scrollbars>
                    </div>
                </div>

            </Modal>
        )
    }

    showComment(text, map) {
        var reg = /(\[[^\]]+\])/;

        var matchResult = text.match(reg);
        if (!matchResult) {
            //未匹配出表情
            return <span>{text}</span>
        } else {
            //替换表情
            var tag;
            var key = matchResult[0];
            var url = map[key];
            if (url) {
                //查询到表情
                tag = "<img style='width:20px;height:20px;margin:0px 2px;' src=" + url + ">" //<img src={url} style={{width:'20px',height:'20px',margin:'0px 2px'}}></img>
            } else {
                //为查询到表情
                tag = <span>{key}</span>
            }

            return (
                <span>{text.substr(0, matchResult.index)}
                    <span
                        dangerouslySetInnerHTML={{__html: tag}}></span>{this.showComment(text.substr(matchResult.index + key.length), map)}
                </span>
            );
        }
    }

    //点赞加载更多
    likedMore() {
        this.state.pageNoLiked++;
        this.getLiked();
    }

    //分享加载更多
    shareMore() {
        this.state.pageNoShare++;
        this.getShare();
    }

    //点击加载更多评论
    markMore() {
        this.state.pageNo++;
        this.getMarked()
    }

    //微博评论
    createWeiboComment() {
        let body = {
            id: this.state.id,
            text: this.state.myInput,
        };
        if (this.state.myInput) {
            if (!this.state.myInput.trim().length > 0) {
                message.warn('请输入评论内容！');
                return;
            }
        } else {
            message.warn('请输入评论内容！');
            return;
        }
        createComment(body, (data) => {
            this.state.myInput = '';
            this.state.pageNo = 1;
            this.props.refresh && this.props.refresh();
            this.getMarked()
        })
    }

    //回复评论
    replyComments(item) {
        let body = {
            id: this.state.id,
            commentId: item.idstr,
            text: item.mark
        };
        if (item.mark) {
            if (!item.mark.trim().length > 0) {
                message.warn('请输入评论内容！');
                return;
            }
        } else {
            message.warn('请输入评论内容！');
            return;
        }
        replyComment(body, (data) => {
            this.state.myInput = '';
            this.state.pageNo = 1;
            this.props.refresh && this.props.refresh();
            this.getMarked()
        })
    }

    //删除评论
    deleteMark(item) {
        confirm({
            title: '是否要删除本条评论 ？',
            onOk: () => {
                let body = {
                    id: this.state.id,
                    commentId: item.idstr
                };
                delComment(body, (data) => {
                    this.state.pageNo = 1;
                    this.props.refresh && this.props.refresh();
                    this.getMarked()
                })
            },
            onCancel() {
            },
        });
    }

    //微博，分享，点赞，评论的微博头像和名称点击打开微博
    openBlankWeiBo(idstr) {
        window.open('https://www.weibo.com/u/' + idstr)
    }

    //表情包
    renderEmotionsDataSource(item) {
        if (this.state.emotionsDataSource.length === 0) {
            return <Empty/>
        }
        return (<div style={{width: "440px"}}>
            <Tabs type="line" size="small" tabBarGutter={0}>
                {
                    this.getEmotionType(item).map(etype => {
                        return etype;
                    })
                }
            </Tabs>
        </div>);
    }

    getEmotionType(item) {
        let types = [];
        let emotionTypes = this.state.emotionsDataSource;
        for (let i = 0; i < emotionTypes.length; i++) {
            let emotionType = emotionTypes[i];
            types.push(<TabPane tab={emotionType.category} key={i}>
                <table>
                    <tbody>
                    {
                        this.setEmotions(emotionType.emotion, item).map(tr => {
                            return <tr key={uuid()}>
                                {tr.map(td => {
                                    return <td key={uuid()} width={36} height={34} align={"center"}
                                               style={{border: "1px solid #e8e8e8"}}>{td}</td>;
                                })}
                            </tr>
                        })
                    }
                    </tbody>
                </table>
            </TabPane>);
        }
        return types;
    }

    setEmotions(emotions, item) {
        let rowNum = 15; //一行显示15个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for (let i = 0; emotions && i < emotions.length; i++) {
            let emotion = emotions[i];
            tdComponent.push(<img width={26} style={{padding: "2px", cursor: "pointer"}}
                                  onClick={this.insertEmotion.bind(this, emotion, item)} title={emotion.value}
                                  src={emotion.icon}/>);
            if (saveIndex == (rowNum)) {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            } else {
                if (i == (emotions.length - 1)) {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    insertEmotion(emotion, item) {
        if (item.idstr) {
            //回复评论，里面添加表情
            item.mark = item.mark + emotion.value;
            this.setState({})
        } else {
            this.setState({myInput: this.state.myInput + emotion.value});
        }
        /* let newValue = this.contentWapper.insetIntoTextArea(emotion.value);
         this.setContent(newValue);*/
    }
}

class WeiboImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            picUrls: this.props.picUrls
        }
    }

    showPics(pics) {
        let rows = [];
        rows.push(
            <table key={uuid()}>
                <tbody>
                {
                    this.setPics(pics).map(tr => {
                        return <tr key={uuid()}>
                            {tr.map(td => {
                                return <td key={uuid()} width={36} height={34} align={"center"}>{td}</td>;
                            })}
                        </tr>
                    })
                }
                </tbody>
            </table>
        );
        return rows;
    }

    setPics(pics) {
        let rowNum = 3; //一行显示3个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for (let i = 0; pics && i < pics.length; i++) {
            let pic = pics[i];
            tdComponent.push(<img style={{padding: "2px"}} width={120} height={120} src={pic}/>);
            if (saveIndex == (rowNum)) {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            } else {
                if (i == (pics.length - 1)) {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    render() {
        return (
            <div style={{width: "360px"}}>
                {this.showPics(this.state.picUrls)}
            </div>
        )
    }
}